// @flow
import React from 'react'

const Ban = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
      <g fill="none" fillRule="evenodd">
        <path d="M-1-1h24v24H-1z" />
        <g stroke="#6e7b8c" transform="translate(.5 .5)">
          <path d="M18.8 3.2L3.2 18.8" />
          <circle cx="11" cy="11" r="11" strokeLinecap="square" />
        </g>
      </g>
    </svg>
  )
}

export default Ban



// WEBPACK FOOTER //
// ./src/components/Icons/Ban.js